import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Styles/style'
import { SearchInput } from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Styles/style'
import React, { useEffect, useState } from 'react'

const CollegeNameFilter = ({
  collegeList,
  college,
  setCollege,
  searchWidth,
}) => {
  const [updatedList, setUpdatedList] = useState([])
  const [filteredLocations, setFilteredLocations] = useState([])
  const [searchInput, setSearchInput] = useState('')

  useEffect(() => {
    setUpdatedList(collegeList || [])
  }, [collegeList])

  const handleSearchInput = e => {
    const searchTerm = e?.target?.value?.toLowerCase()
    setSearchInput(searchTerm)

    const filteredCities = updatedList?.filter(option =>
      option?.instituteCampusName?.toLowerCase()?.includes(searchTerm)
    )

    setFilteredLocations(filteredCities)
  }

  return (
    <Wrapper column>
      <SearchInput
        placeholder="Search by college name"
        bordered={true}
        onChange={handleSearchInput}
        width={searchWidth || '450px'}
      />
      <FilterCheckBoxComp
        onChange={values => setCollege([values[values?.length - 1]])}
        value={college}
        options={searchInput ? filteredLocations : updatedList}
        valueParam="instituteCampusName"
        labelParam="instituteCampusName"
      />
    </Wrapper>
  )
}

export default CollegeNameFilter
